import ErrorMessage from '@shared/components/ErrorMessage/ErrorMessage';
import Input from '@shared/components/InputGroup/Input';
import cx from 'classnames';
import { ChangeEvent, ReactNode } from 'react';

import { ReactComponent as LinkNew } from 'assets/icons/LinkNew.svg';
import { IconType } from 'utils/types';

interface AliasInputProps {
  value: string;
  postfix: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  AliasIcon?: IconType;
  onAliasIconClick?: () => void;
  isAliasCheckLoading?: boolean;
  iconClassName?: string;
  hasError: boolean;
  errorMessage?: string;
  AliasAvailabilityComponent?: ReactNode;
  dataTestId?: string;
  hintText?: string;
  hideIcon?: boolean;
}

const AliasInput = ({
  value,
  postfix,
  onChange,
  placeholder,
  AliasIcon,
  onAliasIconClick,
  isAliasCheckLoading,
  iconClassName,
  hasError,
  errorMessage,
  AliasAvailabilityComponent,
  dataTestId,
  hintText,
  hideIcon,
}: AliasInputProps) => (
  <div className="flex min-w-0 gap-5">
    {!hideIcon && <LinkNew className="stroke-gray-60 mt-3 h-6 w-6 shrink-0 stroke-1.5" />}
    <div className="flex w-full min-w-0 flex-col gap-2">
      {hintText && <span className="text-size-sm text-black">{hintText}</span>}
      <div className="flex gap-2">
        <Input
          variant="white-bg"
          onChange={onChange}
          containerClassName="!w-3/4"
          hasError={hasError}
          value={value.toLowerCase()}
          placeholder={placeholder}
          icon={AliasIcon}
          onIconClick={onAliasIconClick}
          iconClassName={cx({ 'animate-spin': isAliasCheckLoading }, iconClassName)}
          className="!bg-gray-10"
          data-testid={dataTestId}
        />
        <Input variant="white-bg" containerClassName="!w-36" disabled value={postfix} />
      </div>
      {AliasAvailabilityComponent}
      <ErrorMessage message={errorMessage} className="!mt-0" />
    </div>
  </div>
);

export default AliasInput;
